import React from 'react';
import { formatCurrency } from '../../utils/currencyFormatter';
import { PackageIcon, FileTextIcon, TicketIcon, UsersIcon, CalendarIcon, AlertTriangleIcon, ArrowRightIcon } from 'lucide-react';
export function LicenseDashboard({
  locale,
  onNavigate
}) {
  // Mock data for the dashboard
  const summaryData = {
    totalModules: 8,
    activeModules: 6,
    volumeUsage: {
      current: 75420,
      limit: 100000,
      metric: 'Documents',
      percentage: 75
    },
    occasionalPasses: {
      remaining: 42,
      used: 18,
      total: 60
    },
    activeSessions: 14,
    renewalDue: 45
  };
  const alerts = [{
    id: 'alert-1',
    type: 'warning',
    message: 'Vendor Management module license expires in 7 days',
    action: 'Renew Now',
    module: {
      id: 'module-2',
      name: 'Vendor Management'
    }
  }, {
    id: 'alert-2',
    type: 'danger',
    message: 'Document volume usage at 75% of limit',
    action: 'Upgrade Plan',
    plan: {
      id: 'plan-1',
      name: 'Enterprise Document Plan'
    }
  }];
  return <div className="space-y-6" data-id="element-16337">
      {/* Summary Cards */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5" data-id="element-16338">
        {/* Licensed Modules */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-16339">
          <div className="px-4 py-5 sm:p-6" data-id="element-16340">
            <div className="flex items-center" data-id="element-16341">
              <div className="flex-shrink-0 bg-indigo-100 rounded-md p-3" data-id="element-16342">
                <PackageIcon className="h-6 w-6 text-indigo-600" data-id="element-16343" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-16344">
                <dl data-id="element-16345">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-16346">
                    Licensed Modules
                  </dt>
                  <dd data-id="element-16347">
                    <div className="text-lg font-medium text-gray-900" data-id="element-16348">
                      {summaryData.activeModules} / {summaryData.totalModules}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-16349">
              <button type="button" onClick={() => onNavigate('modules')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-16350">
                View all modules
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-16351" />
              </button>
            </div>
          </div>
        </div>
        {/* Volume Usage */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-16352">
          <div className="px-4 py-5 sm:p-6" data-id="element-16353">
            <div className="flex items-center" data-id="element-16354">
              <div className="flex-shrink-0 bg-blue-100 rounded-md p-3" data-id="element-16355">
                <FileTextIcon className="h-6 w-6 text-blue-600" data-id="element-16356" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-16357">
                <dl data-id="element-16358">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-16359">
                    Volume Usage ({summaryData.volumeUsage.metric})
                  </dt>
                  <dd data-id="element-16360">
                    <div className="text-lg font-medium text-gray-900" data-id="element-16361">
                      {summaryData.volumeUsage.current.toLocaleString()} /{' '}
                      {summaryData.volumeUsage.limit.toLocaleString()}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-16362">
              <div className="relative" data-id="element-16363">
                <div className="overflow-hidden h-2 text-xs flex rounded bg-blue-100" data-id="element-16364">
                  <div style={{
                  width: `${summaryData.volumeUsage.percentage}%`
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500" data-id="element-16365"></div>
                </div>
                <div className="text-xs text-gray-500 mt-1 text-right" data-id="element-16366">
                  {summaryData.volumeUsage.percentage}% used
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Occasional Passes */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-16367">
          <div className="px-4 py-5 sm:p-6" data-id="element-16368">
            <div className="flex items-center" data-id="element-16369">
              <div className="flex-shrink-0 bg-green-100 rounded-md p-3" data-id="element-16370">
                <TicketIcon className="h-6 w-6 text-green-600" data-id="element-16371" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-16372">
                <dl data-id="element-16373">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-16374">
                    Occasional Passes
                  </dt>
                  <dd data-id="element-16375">
                    <div className="text-lg font-medium text-gray-900" data-id="element-16376">
                      {summaryData.occasionalPasses.remaining} remaining
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-16377">
              <button type="button" onClick={() => onNavigate('passes')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-16378">
                Manage passes
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-16379" />
              </button>
            </div>
          </div>
        </div>
        {/* Active Sessions */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-16380">
          <div className="px-4 py-5 sm:p-6" data-id="element-16381">
            <div className="flex items-center" data-id="element-16382">
              <div className="flex-shrink-0 bg-purple-100 rounded-md p-3" data-id="element-16383">
                <UsersIcon className="h-6 w-6 text-purple-600" data-id="element-16384" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-16385">
                <dl data-id="element-16386">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-16387">
                    Active Sessions
                  </dt>
                  <dd data-id="element-16388">
                    <div className="text-lg font-medium text-gray-900" data-id="element-16389">
                      {summaryData.activeSessions} today
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-16390">
              <button type="button" onClick={() => onNavigate('usage')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-16391">
                View usage details
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-16392" />
              </button>
            </div>
          </div>
        </div>
        {/* Renewal Due */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-16393">
          <div className="px-4 py-5 sm:p-6" data-id="element-16394">
            <div className="flex items-center" data-id="element-16395">
              <div className="flex-shrink-0 bg-yellow-100 rounded-md p-3" data-id="element-16396">
                <CalendarIcon className="h-6 w-6 text-yellow-600" data-id="element-16397" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-16398">
                <dl data-id="element-16399">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-16400">
                    Next Renewal
                  </dt>
                  <dd data-id="element-16401">
                    <div className="text-lg font-medium text-gray-900" data-id="element-16402">
                      {summaryData.renewalDue} days
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-16403">
              <button type="button" onClick={() => onNavigate('modules')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-16404">
                View renewals
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-16405" />
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Alerts */}
      <div className="bg-white shadow sm:rounded-lg" data-id="element-16406">
        <div className="px-4 py-5 sm:px-6" data-id="element-16407">
          <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-16408">
            License Alerts
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-16409">
            Important notifications about your licenses and usage
          </p>
        </div>
        <div className="border-t border-gray-200" data-id="element-16410">
          <div className="divide-y divide-gray-200" data-id="element-16411">
            {alerts.map(alert => <div key={alert.id} className="px-4 py-4 sm:px-6" data-id="element-16412">
                <div className="flex items-start" data-id="element-16413">
                  <div className={`flex-shrink-0 ${alert.type === 'warning' ? 'text-yellow-400' : 'text-red-400'}`} data-id="element-16414">
                    <AlertTriangleIcon className="h-5 w-5" data-id="element-16415" />
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5" data-id="element-16416">
                    <p className="text-sm font-medium text-gray-900" data-id="element-16417">
                      {alert.message}
                    </p>
                    <div className="mt-3 flex" data-id="element-16418">
                      <button type="button" className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={() => {
                    if (alert.module) {
                      onNavigate('module-detail', alert.module);
                    } else if (alert.plan) {
                      onNavigate('plan-detail', alert.plan);
                    }
                  }} data-id="element-16419">
                        {alert.action}
                      </button>
                    </div>
                  </div>
                </div>
              </div>)}
            {alerts.length === 0 && <div className="px-4 py-5 sm:px-6 text-center text-sm text-gray-500" data-id="element-16420">
                No alerts at this time. All licenses are in good standing.
              </div>}
          </div>
        </div>
      </div>
    </div>;
}